// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--e38f3";
export var layoutMain = "Layout-module--layoutMain--c15f7";